import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login          from "./pages/Login";
import RegisterLanding from "./pages/RegisterLanding";
import OtpVerify      from "./pages/OtpVerify";
import HomePage       from "./portal/home/HomePage";
import Prescriptions  from "./portal/util/Prescriptions";
import MyRefills      from "./portal/util/MyRefills";
import UploadPrescription     from "./portal/util/UploadPrescription";
import Profile        from "./portal/util/Profile";
import FriendsFamily  from "./portal/util/FriendsFamily";
import { AuthProvider }       from "./auth/AuthContext";
import ProtectedRoute         from "./auth/ProtectedRoute";
import PhoneVerifiedRoute     from "./auth/PhoneVerifiedRoute";
import NotificationsPage      from "./portal/util/NotificationsPage";
import MyInvoices             from "./portal/util/MyInvoices";
import FindDoctor             from "./portal/util/FindDoctor";
import BookAppointment        from "./portal/util/BookAppointment";
import MyAppointments         from "./portal/util/MyAppointments";
import HealthHistory          from "./portal/util/HealthHistory";
import { PortalDataProvider } from "./portal/context/PortalDataContext";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PortalDataProvider>
          <Routes>
            {/* Public */}
            <Route path="/login"    element={<Login />} />
            <Route path="/register" element={<RegisterLanding />} />

            {/* Authenticated but phone not yet verified */}
            <Route path="/verify-phone" element={
              <ProtectedRoute><OtpVerify /></ProtectedRoute>
            } />

            {/* Fully authenticated (token + phone verified) */}
            <Route path="/" element={
              <PhoneVerifiedRoute><HomePage /></PhoneVerifiedRoute>
            } />
            <Route path="/home" element={
              <PhoneVerifiedRoute><HomePage /></PhoneVerifiedRoute>
            } />
            <Route path="/prescriptions" element={
              <PhoneVerifiedRoute><Prescriptions /></PhoneVerifiedRoute>
            } />
            <Route path="/refills" element={
              <PhoneVerifiedRoute><MyRefills /></PhoneVerifiedRoute>
            } />
            <Route path="/upload" element={
              <PhoneVerifiedRoute><UploadPrescription /></PhoneVerifiedRoute>
            } />
            <Route path="/profile" element={
              <PhoneVerifiedRoute><Profile /></PhoneVerifiedRoute>
            } />
            <Route path="/relatives" element={
              <PhoneVerifiedRoute><FriendsFamily /></PhoneVerifiedRoute>
            } />
            <Route path="/notifications" element={
              <PhoneVerifiedRoute><NotificationsPage /></PhoneVerifiedRoute>
            } />
            <Route path="/invoices" element={
              <PhoneVerifiedRoute><MyInvoices /></PhoneVerifiedRoute>
            } />

            {/* Clinic (FitMe <-> clinic module) */}
            <Route path="/find-doctor" element={
              <PhoneVerifiedRoute><FindDoctor /></PhoneVerifiedRoute>
            } />
            <Route path="/book/:affiliationId" element={
              <PhoneVerifiedRoute><BookAppointment /></PhoneVerifiedRoute>
            } />
            <Route path="/appointments" element={
              <PhoneVerifiedRoute><MyAppointments /></PhoneVerifiedRoute>
            } />
            {/* Legacy standalone clinic routes — folded into the merged
                Prescriptions/Invoices pages as tabs; keep redirecting old
                links (notifications, bookmarks) rather than 404ing. */}
            <Route path="/clinic-prescriptions" element={<Navigate to="/prescriptions?tab=e" replace />} />
            <Route path="/clinic-invoices" element={<Navigate to="/invoices?tab=clinic" replace />} />
            <Route path="/health-history" element={
              <PhoneVerifiedRoute><HealthHistory /></PhoneVerifiedRoute>
            } />
          </Routes>
        </PortalDataProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}